// client/src/components/cursos/FiltroCursos.js
import React, { useState } from 'react';
import { Search, XCircle as ClearIcon } from 'lucide-react';

const initialFilterState = {
    search: '',
    ativo: ''
};

const FiltroCursos = ({ onApplyFilters, loading }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);

    const onChange = e => {
        setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
    };

    const onSubmit = e => {
        e.preventDefault();
        if (onApplyFilters) {
            const activeFilters = Object.fromEntries(
                Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null)
            );
            onApplyFilters(activeFilters);
        }
    };

    const handleClearFilters = () => {
        setLocalFilters(initialFilterState);
        if (onApplyFilters) {
            onApplyFilters({});
        }
    };

    const isAnyFilterActive = () => Object.values(localFilters).some(v => v !== '');

    return (
        <form onSubmit={onSubmit}>
            <div className="form-grid-container-cols-2">
                <div className="form-group">
                    <label htmlFor="filter-search">Buscar</label>
                    <input
                        type="text"
                        name="search"
                        id="filter-search"
                        placeholder="Nome ou descrição..."
                        value={localFilters.search}
                        onChange={onChange}
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="filter-ativo">Status</label>
                    <select
                        name="ativo"
                        id="filter-ativo"
                        value={localFilters.ativo}
                        onChange={onChange}
                        className="form-input"
                    >
                        <option value="">Todos</option>
                        <option value="true">Ativos</option>
                        <option value="false">Inativos</option>
                    </select>
                </div>
            </div>

            <div className="form-actions">
                <button
                    type="button"
                    onClick={handleClearFilters}
                    className="action-button action-button-secondary"
                    disabled={!isAnyFilterActive() || loading}
                >
                    <ClearIcon size={18} className="icon" />
                    Limpar Filtros
                </button>
                <button
                    type="submit"
                    className="action-button action-button-primary"
                    disabled={loading}
                >
                    <Search size={18} className="icon" />
                    Aplicar Filtros
                </button>
            </div>
        </form>
    );
};

export default FiltroCursos;
